import React from 'react'
// TODO move ui
// import { Heading, Text, Button } from '@brainstud/schiphol-vtc-ui'
import { QuestionForm, QuestionMessage } from '../../shared'
import styles from './QuestionCard.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const QuestionCard = props => (
  <div className={cx({
    base: true,
    isCorrect: (props.progress.submited && props.progress.passed) || props.correct,
    isWrong: (props.progress.submited && !props.progress.passed) || props.wrong,
    hasThemeSimple: props.simple,
  })}>
    <div className={styles.header}>
      {props.question.title &&
        <Heading h3 reset>Vraag {props.question.prefix}</Heading>
      }
    </div>
    <div className={styles.content}>
      {props.question.title &&
        <div className={styles.card}>
          <Heading>{props.prefix}{props.question.title}</Heading>

          {props.question.description &&
            <Text html>{props.question.description}</Text>
          }

          <div className={styles.form}>
            {!props.simple && props.question.type === 'single' &&
              <Text italic small>Er is slechts één antwoord juist</Text>
            }
            {!props.simple && props.question.type === 'multiple' &&
              <Text italic small>Meerdere antwoorden zijn mogelijk</Text>
            }
            <QuestionForm
              disabled={props.progress.submited}
              type={props.question.type}
              progress={props.progress}
              answers={props.answers}
              onUpdate={props.onUpdate} />
          </div>

          {!props.quiz.endtest && !props.progress.submited &&
            <Button
              primary label="Controleer" icon="arrow-right" iconPosition="right"
              onClick={props.submitQuestion}
              disabled={!props.progress.answer} />
          }

          {props.progress.submited && props.progress.passed &&
            <QuestionMessage correct message={props.question.message.correct}>
              <Text html>{props.question.message.correct.description}</Text>
            </QuestionMessage>
          }

          {props.progress.submited && !props.progress.passed &&
            <QuestionMessage wrong message={props.question.message.wrong}>
              <Text html>{props.question.message.wrong.description}</Text>
            </QuestionMessage>
          }
        </div>
      }
    </div>
  </div>
)

QuestionCard.defaultProps = {
  question: {},
  progress: {},
}

export default QuestionCard
